import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, NavController,PopoverController } from '@ionic/angular';

// Define the shape of the data we expect
export interface PrivacyDialogData {
  title: string;
  enContent?: string;
  localContent?: string;
  localLanguageName?: string;
}

@Component({
  selector: 'privacy-detail-dialog',
  templateUrl: './privacy-detail-dialog.component.html',
  styleUrls: ['./privacy-detail-dialog.component.scss'],
})
export class PrivacyDetailDialogComponent implements OnInit {
  agreement;
  
  constructor(
      public popoverController: PopoverController,
      private navParams: NavParams,
  ) {
    this.agreement = this.navParams.get('agreement');
  }

  ngOnInit() {
    
  }
  async cancel(){
    await this.popoverController.dismiss();
  }
}
